import { useIsLoggedInRetailer } from "@faire/deprecated-retailer-visitor-shared/lib/isLoggedInRetailer";
import { getModalData } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getModalData";
import { getPaymentDisputeModalData } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getPaymentDisputeModalData";
import { getPromoModalInformation } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getPromoModalInformation";
import { useSettingDecentralizePageData } from "@faire/deprecated-retailer-visitor-shared/settings/useSettingDecentralizePageData";
import { useQuery as usePaymentModalDataQuery } from "@faire/web-api--source/endpoints/www/api/page-data/payment-modal-data/get-hooks";
import { IModalDataResponse } from "@faire/web-api--source/faire/page_data/IModalDataResponse";

export const usePaymentModalData = () => {
  const isLoggedIn = useIsLoggedInRetailer();
  const shouldDecentralizePageData = useSettingDecentralizePageData();
  const { data, isFetching } = usePaymentModalDataQuery({
    staleTime: Infinity,
    refetchOnMount: false,
    enabled: shouldDecentralizePageData && isLoggedIn,
  });

  if (shouldDecentralizePageData) {
    return {
      data,
      isFetching,
    };
  }

  return {
    data: IModalDataResponse.build({
      payment_dispute_modal_data: getPaymentDisputeModalData(),
      modal_data: getModalData(),
      promo_modal_information: getPromoModalInformation(),
    }),
    isFetching: false,
  };
};
